import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { useAdminData } from '../../../../../../../hooks/useAdminData';
import { EventInterface } from '../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../reduxToolkit/typedRedux';
import ConfigTable, { configSection } from '../../../../../../account/ConfigTable';
import { TabContentInterface } from '../../../../../pageBuilder/PBBooths';

const PresentationsSettings = ({ setActions }: TabContentInterface) => {
  const event = useSelector((state) => state.common.event);

  const { t } = useTranslation();
  const { updateEventProperty } = useAdminData(false);

  const [configSections, setConfigSections] = useState<configSection[]>([]);

  useEffect(() => {
    event && updateSections(event);
    setActions([]);
  }, [event]);

  async function updateProp(value: any, path: any) {
    const response = await updateEventProperty(value, path);
    updateSections(response);
  }

  function updateSections(eventData: EventInterface) {
    setConfigSections([
      {
        title: t('config:options'),
        items: [
          {
            title: t('config:presentations-waitingroom-title'),
            description: t('config:presentation-waitingroom-description'),
            value: eventData?.settings.presentations?.waitingRoomActive,
            path: 'settings.presentations.waitingRoomActive',
            type: 'boolean',
          },
          {
            title: t('config:presentations-blockTime-title'),
            description: t('config:presentations-blockTime-description'),
            value: eventData?.settings.presentations.blockTime,
            path: 'settings.presentations.blockTime',
            type: 'number',
          },
          {
            title: t('config:presentationCountdown-title'),
            description: t('config:presentationCountdown-description'),
            value: eventData?.settings.presentationCountdownEnabled,
            path: 'settings.presentationCountdownEnabled',
            type: 'boolean',
          },
          {
            title: t('config:enableOnlinePresentationBooking-title'),
            description: t('config:enableOnlinePresentationBooking-description'),
            value: eventData?.settings.enableOnlinePresentationBooking,
            path: 'settings.enableOnlinePresentationBooking',
            type: 'boolean',
          },
          {
            title: t('config:enablePresentationFavorite-title'),
            description: t('config:enablePresentationFavorite-description'),
            value: eventData?.settings.enablePresentationFavorite,
            path: 'settings.enablePresentationFavorite',
            type: 'boolean',
          },
        ],
      },
    ]);
  }

  return (
    <ConfigTable
      onChange={(value: any, path: string) => {
        return updateProp(value, path);
      }}
      configSections={configSections}
    />
  );
};
export default PresentationsSettings;
